<template>
  <div class="block-common-box">
    <TitleCommon title="Menu Content" />
    <div class="block-common-content">
      <div
        class="slide-btn left-btn"
        :class="{
          'swiper-button-disabled': mySwiperNew && mySwiperNew.isBeginning,
        }"
        @click="mySwiperNew.slidePrev()"
      ></div>
      <div class="swiper-content">
        <div class="swiper-container menuSwiper" id="menuSwiper">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="item in menuArr"
                  :key="item.id"
                >
                <div class="menu-item">
                    <div class="introduce-box">
                        <h2 class="introduce-title">{{ $Getlanguage(item.time) }}</h2>
                        <div class="introduce-content">
                        <p class="content-item">{{ $Getlanguage(item.detail) }}</p>
                        </div>
                    </div>
                    <img class="item-img" :src="$imgUrl + item.src" alt="" />
                    </div>
                </div>
              </div>
            </div>
      </div>
      <div
        class="slide-btn right-btn"
        :class="{ 'swiper-button-disabled': mySwiperNew && mySwiperNew.isEnd }"
        @click="mySwiperNew.slideNext()"
      ></div>
    </div>
  </div>
</template>

<script setup>
import TitleCommon from "./TitleCommon.vue";
import Swiper from "swiper";
import { ref, onMounted } from "vue";
const mySwiperNew = ref(null);


const setSwiper = () => {
  const swiper = new Swiper("#menuSwiper", {
    // autoplay: true, //是否自动播放 true 是  false 否
    centeredSlides: true, // 设定为true时，active slide会居中，而不是默认状态下的居左。
    
    observer: true, //修改swiper自己或子元素时，自动初始化swiper
    observeParents: false, //修改swiper的父元素时，自动初始化swiper
  });
  mySwiperNew.value = swiper;
};
onMounted(() => {
    setSwiper();
})

const menuArr = [
  {
    id: "1",
    src: "/senceD1.png",
    detail: "Afternoon Tea | Coffee",
    time: "Daytime 14:00-18:00",
  },
  {
    id: "2",
    src: "/senceD2.png",
    detail: "Whisky | Cocktail | Party ",
    time: "19:00-04:00",
  },
];
</script>

<style lang="scss" scoped>
.block-common-content {
  width: 100%;
  height: auto;
  position: relative;
  .slide-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    width: 60px;
    height: 60px;
    z-index: 2;
    &.left-btn {
      left: 0;
      background: url($imgUrl + "/ic-left.png") no-repeat center / 60px 60px;
    }
    &.right-btn {
      right: 0;
      background: url($imgUrl + "/ic-right.png") no-repeat center / 60px 60px;
    }
  }
  .swiper-content {
    width: 1230px;
    height: 604px;
    margin: 0 auto;
    overflow: hidden;
  }
  .menuSwiper {
    width: 615px;
    height: 604px;
    overflow: visible;
    margin-left: 0;
    .menu-item {
      width: 100%;
      height: 100%;
      position: relative;
      background: url($imgUrl + "/img_xwbg.png?v=1") no-repeat left center / 521px
        604px;
      padding: 48px;
      box-sizing: border-box;
      .item-img {
        width: 520px;
        height: auto;
        margin-top: 100px;
      }
    }
  }
  .introduce-box {
    width: 100%;
    padding: 0 96px 0 0;
    box-sizing: border-box;
    text-align: center;
    .introduce-title {
      font-size: 26px;
      font-weight: 400;
      color: #e1b180;
      line-height: 40px;
      padding: 20px 0 7px;
    }
    .content-item {
      font-size: 21px;
      font-weight: 400;
      color: #ffffff;
      line-height: 40px;
    }
  }
}
</style>